import { TrayEmptyState, TrayLoadingSkeleton } from '@components/app/panels/right-panel/tray'
import { cn } from '@/utils'
import { PHOTOS_SKELETON_COUNT } from '../constants/photos-skeleton-count'

type PhotosTrayStatusProps = {
  spreadId: string | null
  canShowTray: boolean
  canShowResults: boolean
  hasAlbumSelected: boolean
  isFilenameSearch: boolean
  isRecommendForSpread: boolean
  isFavorites: boolean
  isTrayLoading: boolean
  isTrayError: boolean
  resultCount: number
  /** Grid columns for the loading skeleton — same rule as the loaded tray grid. */
  skeletonColumns?: 1 | 2
}

/** Messages above the Photos grid: pick-an-album and open-a-spread hints, loading, error, empty. */
export function PhotosTrayStatus({
  spreadId,
  canShowTray,
  canShowResults,
  hasAlbumSelected,
  isFilenameSearch,
  isRecommendForSpread,
  isFavorites,
  isTrayLoading,
  isTrayError,
  resultCount,
  skeletonColumns = 2,
}: PhotosTrayStatusProps) {
  return (
    <>
      {!canShowTray && (
        <p className="px-1 py-4 text-sm text-muted-foreground">Select an album to view photos.</p>
      )}

      {hasAlbumSelected && !isFilenameSearch && isRecommendForSpread && !spreadId && (
        <p className="px-1 py-4 text-sm text-muted-foreground">
          Open a spread to load recommendations for this layout.
        </p>
      )}

      {canShowTray && isTrayLoading ? (
        <TrayLoadingSkeleton
          label="Loading photos"
          count={PHOTOS_SKELETON_COUNT}
          columns={skeletonColumns}
          framed
          frameClassName={cn(
            'rounded-md bg-background',
            skeletonColumns === 1 && 'max-w-[var(--panel-single-photo-width)]'
          )}
          itemClassName={cn(
            'motion-reduce:animate-none',
            skeletonColumns === 1 && 'h-[var(--panel-single-photo-height)]'
          )}
        />
      ) : null}

      {canShowTray && isTrayError && !isTrayLoading && !isFavorites && (
        <p className="px-1 py-4 text-sm text-destructive">
          {isFilenameSearch
            ? 'Unable to search photos by filename.'
            : 'Unable to load photos for this album.'}
        </p>
      )}

      {canShowResults && resultCount === 0 ? (
        <TrayEmptyState
          title="No photos found"
          description="Try adjusting your filters or selecting a different album."
        />
      ) : null}
    </>
  )
}
